import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OauthRouteModule } from './oauth-route.module';
import { OauthComponent } from './oauth.component';

@NgModule({
  imports: [
    CommonModule,
    OauthRouteModule
  ],
  declarations: [ OauthComponent ]
})
export class OauthModule { }
